<section class="wagering-preferences-screen" data-cy="wagering-preferences-screen">

  <!-- Sort By -->
  <p class="pref-heading tw-text-[#000000]" data-cy="pref-sort-txt">{{ 'account.preferences.wagering.sortby' | translate: 'Sort By' }}</p>

  <div class="pref-group tw-mb-[16px]">
    <!-- Name -->
    <button
      type="button"
      class="pref-row"
      [disabled]="isDisabled"
      (click)="setPreference('name')"
      data-cy="pref-sort-name"
    >
      <i
        class="pref-dot"
        [class.active]="sortBy === 'Name'"
        data-cy="pref-name-selector"
      ></i>
      <span class="pref-label pref-label--bold tw-text-[#000000]">{{ 'generic.name' | translate: 'Name' }}</span>
    </button>

    <!-- MTP -->
    <button
      type="button"
      class="pref-row"
      [disabled]="isDisabled"
      (click)="setPreference('mtp')"
      data-cy="pref-sort-mtp"
    >
      <i
        class="pref-dot"
        [class.active]="sortBy === 'MTP'"
        data-cy="pref-mtp-selector"
      ></i>
      <span class="pref-label pref-label--bold tw-text-[#000000]">{{ 'generic.mtp' | translate: 'MTP' }}</span>
    </button>
  </div>

  <!-- Wager options -->
  <div class="pref-group tw-mb-[16px]">
    <!-- Clear On Wager -->
    <button
      type="button"
      class="pref-row"
      [disabled]="isDisabled"
      (click)="setPreference('clean-on-wager')"
      data-cy="pref-clear-wager"
    >
      <i
        class="pref-dot"
        [class.active]="isClearWager"
        data-cy="pref-clear-selector"
      ></i>
      <span class="pref-label tw-text-[#000000]">{{ 'account.preferences.wagering.clear' | translate: 'Clear On Wager' }}</span>
    </button>

    <!-- Require Confirmation -->
    <button
      type="button"
      class="pref-row"
      [disabled]="isDisabled"
      (click)="setPreference('require-confirmation')"
      data-cy="pref-req-conf"
    >
      <i
        class="pref-dot"
        [class.active]="requireConfirmation"
        data-cy="pref-req-selector"
      ></i>
      <span class="pref-label tw-text-[#000000]">{{ 'account.preferences.wagering.confirm' | translate: 'Require Confirmation' }}</span>
    </button>

    <!-- Keep Exotic Selections -->
    <button
      type="button"
      class="pref-row"
      [disabled]="isDisabled"
      (click)="setPreference('keep-exotic-selections')"
      data-cy="pref-exotic-sel"
    >
      <i
        class="pref-dot"
        [class.active]="isExoticSelections"
        data-cy="pref-exotic-selector"
      ></i>
      <span class="pref-label tw-text-[#000000]">{{ 'account.preferences.wagering.keepselections' | translate: 'Keep Exotic Selections' }}</span>
    </button>
  </div>

  <!-- Display Event Types -->
  <p class="pref-heading pref-heading--divider tw-text-[#000000]">{{ 'ui.account.display.event.types' | translate: 'Display Event Types' }}</p>

  <div class="pref-group">
    <!-- Thoroughbred -->
    <button
      type="button"
      class="pref-row"
      [disabled]="isDisabled"
      (click)="setPreference('thoroughbred')"
      data-cy="pref-thoroughbred"
    >
      <i
        class="pref-dot"
        [class.active]="isEventTypeExists('Thoroughbred')"
        data-cy="pref-thoroughbred-selector"
      ></i>
      <span class="pref-label tw-text-[#000000]">{{ 'breed.thoroughbred' | translate: 'Thoroughbred' }}</span>
    </button>

    <!-- Harness -->
    <button
      type="button"
      class="pref-row"
      [disabled]="isDisabled"
      (click)="setPreference('harness')"
      data-cy="pref-harness"
    >
      <i
        class="pref-dot"
        [class.active]="isEventTypeExists('Harness')"
        data-cy="pref-harness-selector"
      ></i>
      <span class="pref-label tw-text-[#000000]">{{ 'breed.harness' | translate: 'Harness' }}</span>
    </button>

    <!-- Greyhound -->
    <button
      type="button"
      class="pref-row"
      [disabled]="isDisabled"
      (click)="setPreference('greyhound')"
      data-cy="pref-greyhound"
    >
      <i
        class="pref-dot"
        [class.active]="isEventTypeExists('Greyhound')"
        data-cy="pref-greyhound-selector"
      ></i>
      <span class="pref-label tw-text-[#000000]">{{ 'breed.greyhound' | translate: 'Greyhound' }}</span>
    </button>

    <!-- International -->
    <button
      type="button"
      class="pref-row pref-row--last"
      [disabled]="isDisabled"
      (click)="setPreference('international')"
      data-cy="pref-international"
    >
      <i
        class="pref-dot"
        [class.active]="isEventTypeExists('International')"
        data-cy="pref-international-selector"
      ></i>
      <span class="pref-label tw-text-[#000000]">{{ 'ui.account.international' | translate: 'International' }}</span>
    </button>
  </div>

</section>
